// 因为设计稿的没有考虑到需求要兼容到所有的屏幕。
// 为了让h5 游戏更好的兼容到各个屏幕，整个屏幕的所有元素都要根据 计算出来的比例进行缩放，达到适配所有屏幕的效果。

let fullScreenMode = false;

let getConfigSize = function() {
  let isVerticalGame = !window.pageInfo.horizontal; //是否竖屏
  let orginPhoneWidth = isVerticalGame ? 702 : 2200;
  let orginPhoneHeight = isVerticalGame ? 1182 : 1398; //1144
  let phoneScale = orginPhoneWidth / orginPhoneHeight; //phone 背景图比例
  return {
    isVerticalGame: isVerticalGame,
    minWidth: 1024,
    orginPhoneWidth: orginPhoneWidth,
    orginPhoneHeight: orginPhoneHeight, //1144
    phoneScale: phoneScale, //phone 背景图比例
    minHeight: 1024 * phoneScale,
    desizeWidth: 1920,
    desizeHeight: 1215,
    desizeScale: 1920 / 1215,
    orignAsideWidth: 223,
    orignAsideHeight: 840,
    FULL_SCREEN_MIN_HEIGHT: 400,
    BASE_WIDTH: 0,
    BASE_HEIGHT: 1,
    FULL_SCREEN: 2
  };
};

let isBigScreen = function() {
  // 判定用户屏幕的宽度或者高度比开发这的屏幕大，则 使用根据宽高计算到缩放比例。
  var width = window.innerWidth;
  var height = window.innerHeight;
  return width > 1280 && height > 703;
};

let setPhoneSize = function(el, fullScreen, conf) {
  //先通过屏幕宽高 和设计稿的宽高 去计算元素的缩放比例。
  var el_parent = el.parentElement;
  var winHeight = window.innerHeight;
  var winWidth = window.innerWidth;
  var currentHeight = fullScreen ? conf.FULL_SCREEN_MIN_HEIGHT : conf.minHeight;
  // max(currentHeight,winHeight)
  if (conf.isVerticalGame) {
    var parentHeight = winHeight < currentHeight ? currentHeight : winHeight;
  } else {
    var parentHeight = winHeight < currentHeight ? winHeight : currentHeight;
    parentHeight -= 70;
  }
  // max(winWidth,minWidth)
  var parentWidth = winWidth < conf.minWidth ? conf.minWidth : winWidth;
  // 设置手机壳的大小
  setParentWidth(
    {
      width: parentWidth,
      height: parentHeight
    },
    el_parent
  );
  resizePhoneStyle({
    el,
    parentHeight,
    parentWidth,
    fullScreen,
    conf
  });
};

let resizePhoneStyle = function({
  el,
  parentWidth,
  parentHeight,
  fullScreen,
  conf
}) {
  //如果当前父元素的宽高比例小于设置的比例
  //证明当前浏览器的状态处于 宽度缩小的状态，基于宽度去计算高度
  // 否则，都基于高度去计算宽度
  let resitStyle =
    parentWidth / parentHeight < conf.desizeScale
      ? conf.BASE_WIDTH
      : conf.BASE_HEIGHT;
  resitStyle = fullScreen ? conf.FULL_SCREEN : resitStyle;

  let width = 0;
  let height = 0;
  switch (resitStyle) {
    case conf.BASE_WIDTH:
      {
        width = (parentWidth / conf.desizeWidth) * conf.orginPhoneWidth;
        height = width / conf.phoneScale;
      }
      break;
    case conf.BASE_HEIGHT:
      {
        height = (parentHeight / conf.desizeHeight) * conf.orginPhoneHeight;
        width = height * conf.phoneScale;
      }
      break;
    case conf.FULL_SCREEN:
      {
        var winHeight = window.innerHeight;
        var winWidth = window.innerWidth;
        parentHeight =
          winHeight < conf.FULL_SCREEN_MIN_HEIGHT
            ? conf.FULL_SCREEN_MIN_HEIGHT
            : winHeight;
        height = parentHeight;
        width = height * conf.phoneScale;
      }
      break;
  }
  var scaleRatio = (0.9 * width) / conf.orginPhoneWidth;
  setPhoneStyle({
    el,
    width,
    height,
    scaleRatio,
    conf
  });
  setAsideStyle(el, scaleRatio, conf);
  setOpsContainerStyle(el, scaleRatio, conf);
  setBtnsStyle(el, scaleRatio, conf);
  setcurrentGameStyle(el, scaleRatio, conf);
  setFillScreenBtnStyle(el, scaleRatio, conf);
  setQrCodeStyle(el, scaleRatio, conf);
  setAccountStyle(el, scaleRatio, conf);
  setFloatIconStyle(el, scaleRatio, conf);
  setAsidePopupStyle(el, scaleRatio, conf);
  setGiftPopupStyle(el, scaleRatio, conf);
  setPayTipsStyle(el, scaleRatio, conf);
  setCommonTips(el, scaleRatio, conf);
};

let setCommonTips = function(el, scaleRatio) {
  var ele = el.querySelector(".j-popup-tip");
  if (ele) {
    let reals = scaleRatio + 0.2;
    ele.style.transform = "scale(" + reals + ")";
  }
};

let setPayTipsStyle = function(el, scaleRatio) {
  var ele = el.querySelector(".j-pay-tips");
  if (ele) {
    let reals = scaleRatio + 0.03;
    ele.style.transform = "scale(" + reals + ")";
  }
};

let setGiftPopupStyle = function(el, scaleRatio) {
  var ele = el.querySelectorAll(".j-gift-popup");
  for (let i = 0; i < ele.length; i++) {
    ele[i].style.transform = "scale(" + scaleRatio + ")";
    ele[i].style.transformOrigin = "center";
  }
};

let setAsidePopupStyle = function(el, scaleRatio) {
  var ele = el.querySelector(".j-aside-popup");
  var elebg = el.querySelector(".j-aside-bg");
  if (ele) {
    ele.style.transform = "scale(" + scaleRatio + ")";
    ele.style.transformOrigin = "right top";
  }
  if (elebg) {
    elebg.style.transform = "scaleX(" + scaleRatio + ")";
    elebg.style.transformOrigin = "right";
  }
};

let setFloatIconStyle = function(el, scaleRatio) {
  var ele = el.querySelector(".j-aside-icon");
  if (ele) {
    ele.style.transform = "scale(" + scaleRatio + ")";
    ele.style.transformOrigin = "right";
    ele.style.top = 220 * scaleRatio + "px";
  }
};

let setAccountStyle = function(el, scaleRatio) {
  var account_ele = el.querySelector(".j-account-form-wrapper");
  let reals = scaleRatio - 0.03;
  if (account_ele) {
    account_ele.style.transform = "scale(" + reals + ")";
  }
};

let setAddDesktopAlertStyle = function(el, scaleRatio, parentWidth, conf) {
  // 使用scale 进行缩放，并且是左上角缩放，而不是中心缩放。
  var el_btn = el.querySelector(".j-add-desktop");
  if (el_btn) {
    el_btn.style.transform = "scale(" + scaleRatio + ")";
    el_btn.style.transformOrigin = "0";
    el_btn.style.left = parentWidth + "px";
    // 122 - 162 设计稿上的相对于父元素的绝对定位 值。122 - 162
    el_btn.style.top = conf.isVerticalGame
      ? (122 - 162) * scaleRatio + "px"
      : -10 * scaleRatio + "px";
  }
};

let setQrCodeStyle = function(el, scaleRatio, conf) {
  //0.478003 为 在浏览器中调试得到的一个比较适合的最小值
  var el_qrCode = el.querySelector(".j-qr-code-container");
  if (el_qrCode) {
    scaleRatio = scaleRatio > 0.478003 ? scaleRatio : 0.478003;
    el_qrCode.style.transform = "scale(" + scaleRatio + ")";
  }
};

let setPhoneStyle = function({ el, width, height, scaleRatio, conf }) {
  if (pageInfo.gameSize == "big" && !conf.isVerticalGame) {
    el.style.width = "100%";
    el.style.height = "100%";
    return;
  }
  const originPaddingTop = conf.isVerticalGame ? 99 : 188;
  const originPaddingbottom = conf.isVerticalGame ? 104 : 184;
  const originPaddingLeft = conf.isVerticalGame ? 40 : 264;
  const originPaddingRight = conf.isVerticalGame ? 40 : 264;
  var paddingTop = originPaddingTop * scaleRatio;
  var paddingBtm = originPaddingbottom * scaleRatio;
  var paddingLeft = originPaddingLeft * scaleRatio;
  var paddingRight = originPaddingRight * scaleRatio;
  el.style.width = width + "px";
  el.style.height = height + "px";
  el.style.paddingTop = paddingTop + "px";
  el.style.paddingBottom = paddingBtm + "px";
  el.style.paddingLeft = paddingLeft + "px";
  el.style.paddingRight = paddingRight + "px";

  var vmaxT = -36;
  var hmaxT = -100;
  var topD = conf.isVerticalGame ? vmaxT / scaleRatio : hmaxT * scaleRatio;

  el.style.top = topD + "px";
};

let setParentWidth = function({ width, height }, el_parent) {
  el_parent.style.height = height + "px";
  el_parent.style.width = width + "px";
};

let setAsideStyle = function(el, scaleRatio, conf) {
  scaleRatio = isBigScreen() ? scaleRatio : scaleRatio * 1.15;
  var asideHeight = conf.orignAsideHeight * scaleRatio;
  var asideWidth = conf.orignAsideWidth * scaleRatio;
  var asideTop = 160 * scaleRatio;
  var opersHeight = 418 * scaleRatio;
  var tisWidth = 208 * scaleRatio;
  var tisHeight = 422 * scaleRatio;
  var el_aside = el.querySelector(".j-platform-operas");
  var el_operas = el.querySelector(".j-operas");
  var el_tips = el.querySelector(".j-tips");
  if (el_aside) {
    el_aside.style.width = asideWidth + "px";
    el_aside.style.left = conf.isVerticalGame
      ? -asideWidth - 28 + "px"
      : -asideWidth + 20 + "px";
    el_aside.style.height = asideHeight + "px";
    el_aside.style.top = asideTop + "px";
  }
  if (el_operas) {
    el_operas.style.height = opersHeight + "px";
  }
  if (el_tips) {
    el_tips.style.width = tisWidth + "px";
    el_tips.style.height = tisHeight + "px";
  }

  setAddDesktopAlertStyle(el, scaleRatio, asideWidth, conf);
};

let setOpsContainerStyle = function(el, scaleRatio) {
  scaleRatio = isBigScreen() ? scaleRatio : scaleRatio * 1.15;
  var width = 141 * scaleRatio;
  var height = 257 * scaleRatio;
  var marginTop = 65 * scaleRatio;
  var marginRight = 8 * scaleRatio;
  var gameNameMarginTop = 6 * scaleRatio;
  var fontSize = 18 * scaleRatio;
  var gameNamefontSize = 18 * scaleRatio;
  var el_operasContianer = el.querySelector(".j-ops-contianer");
  if (el_operasContianer) {
    el_operasContianer.style.height = height + "px";
    el_operasContianer.style.width = width + "px";
    el_operasContianer.style.marginTop = marginTop + "px";
    el_operasContianer.style.marginRight = marginRight + "px";
    el_operasContianer.style.fontSize = fontSize + "px";
    el.querySelector(".j-game-name").style.marginTop = gameNameMarginTop + "px";
  }
};

let setcurrentGameStyle = function(el, scaleRatio) {
  let height = 63 * scaleRatio;
  var el_currentGame = el.querySelector(".j-current-game");
  if (el_currentGame) {
    el_currentGame.style.height = height + "px";
  }
};

let setBtnsStyle = function(el, scaleRatio) {
  scaleRatio = isBigScreen() ? scaleRatio : scaleRatio * 1.2;
  var btnHeight = 50 * scaleRatio;
  var el_OpBtns = el.querySelectorAll(".j-ops-btn");
  for (var i = 0, len = el_OpBtns.length; i < len; i++) {
    el_OpBtns[i].style.height = btnHeight + "px";
    el_OpBtns[i].style.lineHeight = btnHeight + "px";
  }
};

let setFillScreenBtnStyle = function(el, scaleRatio, conf) {
  var littleScreenRatio = scaleRatio * 1.5;
  var btnHeight = 147 * littleScreenRatio;

  var btnWdith = 35 * littleScreenRatio;
  if (btnHeight > 110.37 || btnHeight > 26.2786) {
    btnHeight = 110.37;
    btnWdith = 26.2786;
  }
  var right = conf.isVerticalGame
    ? -7 * littleScreenRatio - btnWdith
    : littleScreenRatio * 8;

  var fillScreenBtnTop = 200 * scaleRatio;
  var el_fillScreenBtn = el.querySelector(".j-fill-screen-btn");
  if (el_fillScreenBtn) {
    el_fillScreenBtn.style.top = fillScreenBtnTop + "px";
    el_fillScreenBtn.style.height = btnHeight + "px";
    el_fillScreenBtn.style.width = btnWdith + "px";
    el_fillScreenBtn.style.right = right + "px";
  }
};

export default {
  inserted: function(el, binding) {
    let conf = getConfigSize();
    //当元素 插入到dom 中，才能通过document.querySelector() 获取到对应的元素
    setPhoneSize(el, binding.value, conf);
    window.addEventListener("resize", function() {
      let conf = getConfigSize();
      setPhoneSize(el, fullScreenMode, conf);
    });
  },
  componentUpdated: function(el, binding, oldNode) {
    console.log(binding);
    //当元素的内容发生改变后（全屏）需要重新计算屏幕显示的比例
    if (fullScreenMode != binding.value) {
      let conf = getConfigSize();
      setPhoneSize(el, binding.value, conf);
    }
    fullScreenMode = binding.value;
  }
};



// WEBPACK FOOTER //
// ./src/pages/pc/directive/resize.js